import type { VueI18n } from 'vue-i18n';

export const I18nService = Symbol('I18nService');

export type I18nService = VueI18n;
